// RED-317 PR 3b — what the Studio's floating menus (table, locked card)
// share. They are placed against the page, so inside a scrolling container
// (the Turuülevaated drawer) they must follow that container's scroll, and
// hide once what they point at has scrolled out of sight.

/** The nearest ancestor of `element` that scrolls vertically, else window. */
export function scrollParent(element) {
  for (let node = element?.parentElement; node; node = node.parentElement) {
    if (/(auto|scroll|overlay)/.test(getComputedStyle(node).overflowY)) return node
  }
  return window
}

/** BubbleMenu options: above the anchor's top-right corner, following `scrollTarget`. */
export function menuOptions(scrollTarget) {
  return { placement: 'top-end', offset: 6, shift: { padding: 8 }, hide: true, scrollTarget: scrollTarget ?? window }
}

/** A floating-ui reference for a DOM node; contextElement lets `hide` see its scroll containers. */
export function elementAnchor(dom) {
  return {
    getBoundingClientRect: () => dom.getBoundingClientRect(),
    getClientRects: () => [dom.getBoundingClientRect()],
    contextElement: dom,
  }
}
